import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './NumTextBox.scss';
import ClassNames from 'classnames';
import processNumericValue from 'lib/inputNumberHelper';

const NumTextBox = React.forwardRef(
  (
    {
      onKeyUp,
      onBlur,
      onChange,
      onFocus,
      precision,
      maxLength,
      style,
      value,
      placeholder,
      readOnly,
      disabled,
      className,
      max,
      min,
    },
    ref,
  ) => {
    const [valueState, setValueState] = useState(value);
    useEffect(() => {
      setValueState(value);
    }, [value]);

    const setMinMaxValue = (val) => {
      let newValue = val;

      if (!Number.isNaN(`${newValue}`[0]) && `${newValue}`[1] === '.' && newValue.length === 2 && precision !== 0) {
        return `${setMinMaxValue(newValue[0])}.`;
      }
      if (!Number.isNaN(parseFloat(newValue)) && min !== null && parseFloat(newValue) < min) {
        newValue = min;
      }
      if (!Number.isNaN(parseFloat(newValue)) && max !== null && parseFloat(newValue) > max) {
        newValue = max;
      }
      if (newValue === '-' && min !== null && min >= 0) {
        newValue = value;
      }

      return newValue;
    };

    const onChangeHandler = (e) => {
      let newValue = processNumericValue(e.target.value, min, max, precision);

      if (newValue === null) newValue = valueState;

      setValueState(newValue);

      if (!onChange) return;

      onChange(newValue, e);
    };

    const onBlurHandler = () => {
      let newValue = valueState;
      newValue = setMinMaxValue(newValue);

      if (min && newValue.length === 0) {
        newValue = setMinMaxValue(min);
      }

      setValueState(newValue);

      if (!onBlur) return;

      onBlur(newValue);
    };

    const onKeyUpHandler = (e) => {
      if (e.keyCode !== 13) return;

      const newValue = valueState;

      if (!onKeyUp) return;

      onKeyUp(newValue);
      if (e.keyCode === 13) e.target.blur();
    };

    const onFocusHandler = (event) => {
      onFocus(event);
      event.target.select();
    };

    let props = {};
    if (maxLength) {
      props = {
        ...props,
        maxLength,
      };
    }
    return (
      <input
        ref={ref}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={ClassNames('cmon-NumBox-input ', className)}
        style={style}
        type="text"
        placeholder={placeholder}
        value={valueState}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        onKeyUp={onKeyUpHandler}
        readOnly={readOnly}
        onFocus={onFocusHandler}
        disabled={disabled}
      />
    );
  },
);

NumTextBox.propTypes = {
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  precision: PropTypes.number,
  maxLength: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.any,
  max: PropTypes.any,
  min: PropTypes.any,
};

NumTextBox.defaultProps = {
  value: '',
  placeholder: 'Not set',
  className: null,
  onBlur: () => {},
  onKeyUp: () => {},
  onFocus: () => {},
  onChange: () => {},
  readOnly: false,
  disabled: false,
  precision: 3,
  maxLength: null,
  max: null,
  min: null,
  style: {},
};

export default NumTextBox;
